import { AspectRatio, Badge, Dialog, Flex, IconButton, Inset, Text } from '@radix-ui/themes'
import { ChevronDownIcon, GraduationCapIcon, XIcon } from 'lucide-react'
import { Accordion } from 'radix-ui'

const VimeoEmbed = ({ src, title }: { src: string; title: string }) => (
  <AspectRatio style={{ width: '100%', backgroundColor: 'var(--color-background)' }} ratio={16 / 9} asChild>
    <iframe
      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      title={title}
      height="100%"
      width="100%"
      src={src}
    ></iframe>
  </AspectRatio>
)

export const TutorialsDialog: typeof Dialog.Root = (props) => (
  <Dialog.Root {...props} open={props.open}>
    <Dialog.Content maxWidth="800px" width="75%">
      <Dialog.Title>
        <Flex justify="between" align="center" gap="2">
          <Flex gap="2" align="center">
            <GraduationCapIcon />
            <Text>Tutoriales</Text>
          </Flex>
          <Dialog.Close>
            <IconButton variant="ghost" onClick={() => props.onOpenChange?.(false)} aria-label="Cerrar">
              <XIcon />
            </IconButton>
          </Dialog.Close>
        </Flex>
      </Dialog.Title>
      <Dialog.Description mb="4">
        <Text>Aquí puedes encontrar tutoriales para ayudarte a navegar por la aplicación.</Text>
      </Dialog.Description>

      <Inset side="x">
        <Accordion.Root className="AccordionRoot" type="single" defaultValue="1" collapsible>
          <Accordion.Item className="AccordionItem" value="1">
            <Accordion.Trigger className="AccordionTrigger">
              <Flex gap="2">
                <Badge variant="outline" color="gray">
                  1
                </Badge>
                <Text>Primeros Pasos</Text>
              </Flex>
              <ChevronDownIcon />
            </Accordion.Trigger>
            <Accordion.Content className="AccordionContent">
              <VimeoEmbed
                src="https://player.vimeo.com/video/1106158088?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                title="Primeros Pasos"
              />
            </Accordion.Content>
          </Accordion.Item>
          <Accordion.Item value="2" className="AccordionItem">
            <Accordion.Trigger className="AccordionTrigger">
              <Flex gap="2">
                <Badge variant="outline" color="gray">
                  2
                </Badge>
                <Text>Vehículos, Consignaciones y Compras</Text>
              </Flex>
              <ChevronDownIcon />
            </Accordion.Trigger>
            <Accordion.Content className="AccordionContent">
              <VimeoEmbed
                src="https://player.vimeo.com/video/1106161085?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                title="Creación Vehiculos, Consignacion y Compras"
              />
            </Accordion.Content>
          </Accordion.Item>
          <Accordion.Item value="3" className="AccordionItem">
            <Accordion.Trigger className="AccordionTrigger">
              <Flex gap="2">
                <Badge variant="outline" color="gray">
                  3
                </Badge>
                <Text>Mensajes, Negocios, Cotizaciones, Reservas, Nota de Venta, Liquidaciones</Text>
              </Flex>
              <ChevronDownIcon />
            </Accordion.Trigger>
            <Accordion.Content className="AccordionContent">
              <VimeoEmbed
                src="https://player.vimeo.com/video/1106161164?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                title="Mensajes, Negocios, Cotizaciones, Reservas, Nota de Venta y Liquidaciones"
              />
            </Accordion.Content>
          </Accordion.Item>
        </Accordion.Root>
      </Inset>
    </Dialog.Content>
  </Dialog.Root>
)
